import type { ActualVsBudgetComparison } from '@/features/actual-vs-budget-production/types'

export type {
  ActualVsBudgetComparison,
  ActualVsBudgetFiscalContext,
  ActualVsBudgetFund,
  ActualVsBudgetPeriod,
  ActualVsBudgetPerformanceClassification,
  ActualVsBudgetState,
  ActualVsBudgetTrendSeries,
  CompanyActualVsBudget as CompanyActualVsBudgetResponse,
} from '@/features/actual-vs-budget-production/types'

export type CompanyActualVsBudgetMetric = 'Revenue' | 'EBITDA'

export const OVERVIEW_ACTUAL_VS_BUDGET_METRICS = ['Revenue'] as const
export const FINANCIALS_ACTUAL_VS_BUDGET_METRICS = [
  'Revenue',
  'EBITDA',
] as const

export function buildCompanyActualVsBudgetRequest(
  companyId: string,
  metrics: readonly CompanyActualVsBudgetMetric[] = OVERVIEW_ACTUAL_VS_BUDGET_METRICS
) {
  return {
    url: `/companies/${companyId}/actual-vs-budget`,
    params: {
      period: 'FYTD' as const,
      metrics: metrics.join(','),
    },
  }
}

export function getActualVsBudgetStateMessage(
  comparison: ActualVsBudgetComparison
): string | null {
  switch (comparison.state) {
    case 'MATCHED':
      return null
    case 'ZERO_BUDGET':
      return 'Budget is zero for this fiscal period. Percentage variance is unavailable.'
    case 'MISSING_BUDGET':
      return 'Budget data is not available for this company.'
    case 'UNMATCHED_PERIOD':
      return 'Budget data does not match this fiscal period.'
    case 'INCOMPLETE_MATCH':
      return `Actual and Budget coverage is incomplete: ${comparison.matchedPeriods} of ${comparison.expectedPeriods} months matched.`
    case 'ACTUAL_MISSING':
      return 'Actual data is not available for this fiscal period.'
  }
}
